import { buildParams } from 'app/utils/pagination';
import * as commonApi from './commons';

export const getGrammars = async (params, type = 'all') => {
  const cacheKey = `grammars_${params.code}_${type}`;
  const paramsUrl = buildParams(params);
  const path = `/api/grammars${paramsUrl}`;

  const grammars = await commonApi.list(cacheKey, path);
  return grammars?.data;
};

export const getBySlug = async (slug: string, code: string) => {
  const cacheKey = `blogs_info_${code}:${slug}`;
  const path = `/api/grammars/${slug}${buildParams({ code })}`;

  const grammar = await commonApi.list(cacheKey, path);

  return grammar?.data;
};
